<page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
<page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

<form [formGroup]="form">
  <div class="row">
    <div class="col-xs-12 col-md-3">
      <div class="photo-upload text-center">
        <div *ngIf="profilePictureUrl" class="preview">
          <img [src]="profilePictureUrl" alt="Foto de perfil" class="profile-picture-preview" />
        </div>
        <button mat-raised-button color="primary" (click)="fileInput.click()">Escolher Foto</button>
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" style="display: none" />

        <mat-error *ngIf="form.get('photo')?.hasError('maxFileSize') ">
          O arquivo deve ter um tamanho menor que 4mb
        </mat-error>

        <mat-error *ngIf="form.get('photo')?.hasError('invalidFileType') ">
          Permitido apenas imagems em png e jpeg
        </mat-error>
      </div>
    </div>

    <div class="col-xs-12 col-md-9">
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input type="text" matInput formControlName="name" placeholder="Nome" required />
            <mat-error *ngIf="form.get('name')?.hasError('required')">Campo obrigatório.</mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('pattern')">Informe um nome válido (somente letras e
              espaços).</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-md-6">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Email</mat-label>
            <input type="text" matInput formControlName="email" placeholder="Email" required readonly />
            <mat-error *ngIf="form.get('email')?.hasError('email')">Informe um email válido.</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Data de nascimento</mat-label>
            <input type="text" matInput formControlName="birthDate" placeholder="Data de nascimento" mask="00/00/0000"
              required />
            <mat-error *ngIf="form.get('birthDate')?.hasError('required')">Campo obrigatório.</mat-error>
            <mat-error *ngIf="form.get('birthDate')?.hasError('datevalidator')">Informe uma data de nascimento
              válida.</mat-error>
            <mat-error *ngIf="form.get('birthDate')?.hasError('underAge')">
              É preciso ser maior de Idade
            </mat-error>
            <mat-error *ngIf="form.get('birthDate')?.hasError('overAge')">
              Entre com uma idade realista (Idade não pode exceder 120 anos).
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>CPF</mat-label>
            <input type="text" matInput formControlName="cpf" placeholder="CPF" mask="000.000.000-00" required />
            <mat-error *ngIf="form.get('cpf')?.hasError('required')">Campo obrigatório.</mat-error>
            <mat-error *ngIf="form.get('cpf')?.hasError('cpfInvalid')">Informe um CPF válido.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Celular</mat-label>
            <input matInput type="text" formControlName="mobile" mask="(00) 00000-0000" prefix="+55 "
              [dropSpecialCharacters]="true" placeholder="(11) 91234-5678" required />
            <mat-error *ngIf="form.get('mobile')?.hasError('phoneInvalid')">Informe um número de celular
              válido.</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xs-12 btCriar">
    <button mat-flat-button color="primary" (click)="salvar()" *ngIf="mode == 'UPDATE'"
      [disabled]="form.invalid || loading">
      <span *ngIf="!loading">Salvar</span>
      <ng-container *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
      </ng-container>
    </button>

    <button mat-flat-button color="primary" (click)="create()" *ngIf="mode == 'CREATE'"
      [disabled]="form.invalid || loading">
      <span *ngIf="!loading"> Criar conta</span>

      <ng-container *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
      </ng-container>
    </button>
  </div>
</form>